export default __webpack_public_path__ + "static/media/christmasGiftDonationChi.4b5c354b.jpg";